import $ from "jquery";

class SendAjax{
	url = window.ajaxurl;

	constructor( obj_but, action, event, file = false ){
		this._action = action;
		this._event = event;
		this._obj_but = $( obj_but );
		this._file = file;

		this._sendData = {
			action : this._action,
			event : this._event,
		};

		this.beforeSend = function(){
			this._obj_but.prop( "disabled", true );
		};

		this.successSend = function( responseData ){};

		this.error = function( responseData ){};

		this.complete = function( responseData ){};
	}

	convertSendData( data ){
		const convertedData = {};

		data.forEach( ( field ) => {
			convertedData[ field.name ] = field.value;
		} );

		return convertedData;
	}

	prepareSendData( data ){
		if( typeof data === "string" ){
			this._sendData =
				"action=" + this._action + "&event=" + this._event + "&" + data;
		} else if( this._file === true ){
			this._sendData = data;
			this._sendData.append( "action", this._action );
			this._sendData.append( "event", this._event );
		} else {
			const prepData = Object.assign(
				{
					action : this._action,
					event : this._event,
				},
				data
			);

			for( const data in prepData ){
				if( $.trim( prepData[ data ] ) === "" ){
					delete prepData[ data ];
				}
			}
			this._sendData = prepData;
		}
	}

	send(){
		return $.ajax( {
			method : "POST",
			url : this.url,
			contentType :
				this._file === true
					? false
					: "application/x-www-form-urlencoded; charset=UTF-8",
			processData : this._file !== true,
			data : this._sendData,
			beforeSend : () => {
				return this.beforeSend();
			},
			success : ( response ) => {
				const responseData = JSON.parse( response );
				if( responseData.status === "success" ){
					this.successSend( responseData.data );
				} else if(
					responseData.status === "error" &&
					responseData.errors !== undefined
				){
					this.error( responseData );
				}
			},
			complete : ( response ) => {
				this.complete( response );
			},
		} );
	}
}

export default SendAjax;